function init() {

    const dropdown = document.getElementById("country-dropdown");
    if (dropdown) {
        dropdown.addEventListener('change', setCountryStateElement);
        setCountryStateElement();
    }

}

function setCountryStateElement() {
    var selectedValue = document.getElementById("country-dropdown").value;
    var selectedValueArray = selectedValue.split(' - ');

    document.getElementById("@Model.FormElement.Guid").value = selectedValueArray[2];

    var regionElement = document.getElementsByClassName("RBU__c");
    var countryCodeElement = document.getElementsByClassName("countrycode");
    var countryElement = document.getElementsByClassName("country");
    if (regionElement.length) {
        regionElement[0].value = selectedValueArray[1];
    }
    if (countryCodeElement.length) {
        countryCodeElement[0].value = selectedValueArray[0];
    }
    if (countryElement.length) {
        countryElement[0].value = selectedValueArray[2];
    }
};

export default {
    init
}